import { render, staticRenderFns } from "./LetterView.vue?vue&type=template&id=061b7090&"
import script from "./LetterView.vue?vue&type=script&lang=js&"
export * from "./LetterView.vue?vue&type=script&lang=js&"
import style0 from "./LetterView.vue?vue&type=style&index=0&id=061b7090&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports